import { ConfigInterface } from 'swr';
import { wpApi, useWPApi, QueryParams, parseUrl } from '@gik/core/api';
import WordpressSituation from '@gik/core/models/wordpress/WordpressSituation';

const path = 'situation';

function getParams(ids: number[]): QueryParams {
  return {
    include: ids,
  };
}

export function getSituationsById(ids: number[]) {
  const finalUrl = parseUrl(path, {
    searchParams: getParams(ids),
    withAllPages: true,
  });
  return wpApi.get(finalUrl);
}

export function useSituationsById(ids: number[], config?: ConfigInterface) {
  // important: the path must be null if there is no slug yet, this is to prevent any loading from happening
  return useWPApi<WordpressSituation[]>(path, config, { searchParams: getParams(ids), withAllPages: true });
}
